import { environment } from '../environment/environment'
import { getToken } from './utilities'

export const createApplePayDiagnostics = () => {
    const bytes = new Uint32Array(4)
    window.crypto.getRandomValues(bytes)
    const attemptId = Array.from(bytes, value => value.toString(16)).join('-')
    const started = Date.now()
    const report = (stage: string, details: Record<string, unknown> = {}, error?: any) => {
        // Only explicitly selected metadata leaves the browser, never payment data.
        const payload = {
            attempt_id: attemptId, stage, hostname: window.location.hostname,
            elapsed_ms: Date.now() - started,
            order_id: details.order_id, bog_order_id: details.bog_order_id,
            merchant_domain: details.merchant_domain,
            merchant_expires_at: details.merchant_expires_at,
            merchant_session_present: details.merchant_session_present,
            error_name: typeof error?.name === 'string' ? error.name.slice(0, 100) : undefined,
            error_code: typeof error?.code === 'string' || typeof error?.code === 'number' ? String(error.code).slice(0, 100) : undefined,
            error_message: typeof error?.message === 'string' ? error.message.slice(0, 300)
                : typeof error?.info === 'string' ? error.info.slice(0, 300) : undefined,
            http_status: typeof error?.status === 'number' ? error.status : undefined,
        }
        // Do not delay the user gesture or let logging failures affect checkout.
        void getToken().then(token => fetch(`${environment.basePath}/rest_apple_pay_diagnostic`, {
            method: 'POST', keepalive: true,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify(payload),
        })).catch(() => undefined)
    }
    return { attemptId, report }
}
